import types from './mutation-types';

export default {};
